import type { SVGProps } from 'react';
import * as React from 'react';

const DevicePhoneMobileIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="solid/device-phone-mobile">
      <g id="Icon">
        <path
          d="M9.60005 19.5002C9.60005 19.0031 10.003 18.6002 10.5 18.6002H13.5C13.9971 18.6002 14.4 19.0031 14.4 19.5002C14.4 19.9973 13.9971 20.4002 13.5 20.4002H10.5C10.003 20.4002 9.60005 19.9973 9.60005 19.5002Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.80005 4.8002C4.80005 2.81197 6.41182 1.2002 8.40005 1.2002H15.6C17.5883 1.2002 19.2 2.81197 19.2 4.8002V19.2002C19.2 21.1884 17.5883 22.8002 15.6 22.8002H8.40005C6.41182 22.8002 4.80005 21.1884 4.80005 19.2002V4.8002ZM9.60005 3.0002V3.9002C9.60005 4.39725 10.003 4.8002 10.5 4.8002H13.5C13.9971 4.8002 14.4 4.39725 14.4 3.9002V3.0002H15.6C16.5942 3.0002 17.4 3.80608 17.4 4.8002V19.2002C17.4 20.1943 16.5942 21.0002 15.6 21.0002H8.40005C7.40594 21.0002 6.60005 20.1943 6.60005 19.2002V4.8002C6.60005 3.80608 7.40594 3.0002 8.40005 3.0002H9.60005Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);
export default DevicePhoneMobileIcon;
